import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HandsetService } from '../../../core/services/handset.service';

@Component({
standalone: false,
  selector: 'app-card',
  styleUrls: ['./card.component.scss'],
  templateUrl: './card.component.html',
})
export class CardComponent {
  private _titleStyle: any;
  private _subtitleStyle: any;
  private _style: any;

  @Input() public headerIcon: string;
  @Output() public clickHeaderIconEvent = new EventEmitter<any>();
  @Input() public title: string;
  @Input() public subtitle: string;
  @Input() public bigHeaders: boolean;
  @Input() public sidePaddings;
  @Input() public mobileSidePaddings;
  @Input() public topPadding;
  @Input() public border;
  @Input() public bottomPadding;
  @Input() public height;
  @Input() public width;

  @Input()
  set titleStyle(value: any) {
    this._titleStyle = value;
  };

  @Input()
  set subtitleStyle(value: any) {
    this._subtitleStyle = value;
  }

  @Input()
  set style(value: any) {
    this._style = value;
  }


  constructor(public handsetService: HandsetService) {
  }

  public onClickHeaderIcon() {
    this.clickHeaderIconEvent.emit(true);
  }

  public get getStyle() {
    let style;
    if (this.handsetService.isMobile) {
      style = {
        'padding-left': (this.mobileSidePaddings ? this.mobileSidePaddings : '3rem'),
        'padding-right': (this.mobileSidePaddings ? this.mobileSidePaddings : '3rem'),
        'padding-top': (this.topPadding ? this.topPadding : '2rem'),
        'padding-bottom': (this.bottomPadding ? this.bottomPadding : '32px'),
        border: 0,
      };
    } else {
      style = {
        'padding-left': (this.sidePaddings ? this.sidePaddings : '3rem'),
        'padding-right': (this.sidePaddings ? this.sidePaddings : '3rem'),
        'padding-top': (this.topPadding ? this.topPadding : '2rem'),
        'padding-bottom': (this.bottomPadding ? this.bottomPadding : '32px'),
        height: this.height,
        width: this.width,
        border: this.border ? this.border : null
      };
    }
    if (this._style) {
      return Object.assign({}, style, this._style);
    } else {
      return style;
    }
  }


  get subtitleStyle() {
    if (this._subtitleStyle) {
      return this._subtitleStyle;
    } else {
      return {};
    }
  }

  get titleStyle() {
    if (this._titleStyle) {
      return this._titleStyle;
    } else {
      return {};
    }
  }

}
